import { Button } from "@/components/ui/button";
import { Lightbulb } from "lucide-react";

const Lighting = () => {
  return (
    <section className="py-32 relative overflow-hidden bg-dark-section">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=2000&q=80")',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-dark-section/95 via-dark-section/90 to-primary/20" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-primary/20 to-primary/10 mb-8 animate-scale-in">
            <Lightbulb className="w-12 h-12 text-primary" />
          </div>
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-montserrat font-bold mb-8 text-white animate-fade-in">
            ILUMINA TUS ESPACIOS CON ESTILO Y EFICIENCIA
          </h2>
          
          <p className="text-lg md:text-xl text-white/80 font-inter leading-relaxed mb-12 animate-fade-in text-justify hyphens-auto" style={{ animationDelay: '200ms', textAlignLast: 'center' }}>
            Te asesoramos y te guiamos a elegir la iluminación adecuada para cada espacio o proyecto que necesites.
          </p>
          
          <Button 
            size="lg" 
            className="glass-liquid-medium hover-liquid text-white font-montserrat font-bold px-12 py-6 text-lg rounded-full shadow-liquid-lg hover:shadow-liquid-xl backdrop-blur-xl"
            onClick={() => document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' })}
          >
            CONSULTAR AHORA
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Lighting;
